import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowForward = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 14 14",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M2.9165 6.99935H11.0832M6.99984 11.0827L11.0832 6.99935L6.99984 2.91602",
		stroke: "currentColor",
		strokeWidth: 1.17,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgArrowForward;
